import { ActionForm } from "@/components/actions/ActionForm";
import { ActionService, type Action } from "@/services/ActionService";
import { useEffect, useState } from "react";
import { useParams } from "react-router";

const ActionEditPage: React.FC = () => {
  const params = useParams();
  const [action, setAction] = useState<Action | null>(null);

  useEffect(() => {
    const fetchAction = async () => {
      const actionData = await ActionService.getById(params.taskId!);
      if (!actionData) {
        console.error(`Action with ID ${params.taskId} not found`);
        return;
      }
      setAction(actionData);
    };
    fetchAction();
  }, [params.taskId]);

  return (
    <div className="container mx-auto p-4">
      <ActionForm 
        action={action!} 
        primaryButtonText="Update Task"
        onSave={async (action: Action) => {
          if (!params.taskId) {
            throw new Error("No taskId in URL parameters");
          }
          action.tenantId = params.tenantId!;
          await ActionService.update(params.taskId, action);
        }}        
         />
    </div>
  );
};

export default ActionEditPage;
